<ion-card class="survey-carousel__no-survey ion-no-margin">
  <img class="no-surveys-image" alt="No suveys or polls image" src="../assets/img/splash-1@2x.png" />
  <ion-card-header>
    <ion-card-title class="body_1 bold">No Surveys/Polls Available!</ion-card-title>
  </ion-card-header>

  <ion-card-content>
    Well done! You have no more surveys/polls available, you will receive a new one shortly and you will be able to continue winning prizes.
  </ion-card-content>
</ion-card>
